module.exports = __webpack_public_path__ + "static/media/inputcard.add69430.png";